<template>
  <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
  <input
    class="input-text m-reset-input"
    :value="modelValue"
    :type="type"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
});
</script>

<style scoped>
.input-text {
  border-radius: var(--border-radius-sm);
  border: var(--input-border);
  padding: 15px 14px;
  line-height: 150%;
  &:focus {
    outline: none;
    padding: 14px 13px;
    border: var(--input-border-focus);
    box-shadow: var(--box-shadow-100);
  }
}
</style>
